import React from "react";

export default function Spade(props) {
    return (
        <svg className={props.className} viewBox="0 0 64 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.16941 52.2213C-1.72314 45.3287 -1.72313 34.1537 5.16941 27.2612L31.9787 0.451904L31.979 0.452275L31.9791 0.452213L58.8305 27.3037C65.7231 34.1962 65.7231 45.3712 58.8305 52.2638C52.6076 58.4867 42.8938 59.0913 35.9926 54.0774C38.0167 64.847 44.2954 70.7916 47.898 74.1086H48.1848V79.5481H15.726V74.1086H16.0389C17.597 72.7801 25.5009 65.5705 28.0184 54.0269C21.1165 59.0494 11.3957 58.4475 5.16941 52.2213Z" fill="black"/>
        </svg>
    )
}